// Petits comportements du thème Finisher Board. Rien n'est indispensable : sans JavaScript,
// le site reste lisible (menu ouvert par le lien, contenus visibles, panier fonctionnel).
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Menu mobile */
  all('[data-menu-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(open ? 'data-label-close' : 'data-label-open'));
      btn.classList.toggle('is-open', open);
      panel.hidden = !open;
    });
  });

  /* Apparition douce des blocs au défilement */
  var reveals = all('[data-reveal]');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -60px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
    }
  }

  /* Sur écran tactile (pas de survol) : les animations des cartes se jouent une fois à l'apparition */
  if (touch && 'IntersectionObserver' in window) {
    var play = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-play', 'true');
          play.unobserve(e.target);
        }
      });
    }, { threshold: 0.6 });
    all('[data-card]').forEach(function (el) { play.observe(el); });
  }

  /* Compte à rebours jusqu'à la date limite (AAAA-MM-JJ, jusqu'à 23 h 59 heure du visiteur) */
  all('[data-countdown]').forEach(function (el) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-countdown') || '');
    if (!m) return;
    var end = new Date(+m[1], +m[2] - 1, +m[3], 23, 59, 59);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) {
        el.textContent = el.getAttribute('data-text-over') || '';
        return false;
      }
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      var mi = Math.floor((left % 3600000) / 60000);
      el.innerHTML = '';
      var time = document.createElement('time');
      time.setAttribute('datetime', end.toISOString());
      time.textContent = el.getAttribute('data-text-prefix') + ' ' + d + ' ' + el.getAttribute('data-text-days') + ' ' +
        pad(h) + ' ' + el.getAttribute('data-text-hours') + ' ' + pad(mi) + ' ' + el.getAttribute('data-text-minutes');
      el.appendChild(time);
      return true;
    }
    if (tick()) setInterval(tick, 30000);
  });

  /* Sentier en pointillés des étapes : il se dessine au fil du défilement (grand écran) */
  all('[data-trail]').forEach(function (wrap) {
    var svg = wrap.querySelector('.how__trail');
    if (!svg) return;
    function update() {
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = reduce ? 1 : Math.min(1, Math.max(0, (vh * 0.85 - r.top) / Math.max(1, r.height * 0.9)));
      svg.style.clipPath = 'inset(-40px ' + ((1 - p) * 100).toFixed(1) + '% -40px 0)';
    }
    update();
    if (!reduce) {
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
  });

  /* Panier : boutons − et + (le formulaire se renvoie tout seul) */
  all('#cart-form').forEach(function (form) {
    var timer = 0;
    function send() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var u = document.createElement('input');
        u.type = 'hidden';
        u.name = 'update';
        u.value = '1';
        form.appendChild(u);
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }, 450);
    }
    all('[data-qty-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('[data-qty-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        input.value = next;
        send();
      });
    });
    all('[data-qty-input]', form).forEach(function (input) {
      input.addEventListener('change', send);
    });
  });

  /* Carte cadeau : champs du destinataire */
  all('[data-gift-toggle]').forEach(function (box) {
    var fields = document.querySelector('[data-gift-fields]');
    var offset = document.querySelector('[data-gift-offset]');
    if (offset) offset.value = String(new Date().getTimezoneOffset());
    if (!fields) return;
    function sync() {
      fields.hidden = !box.checked;
      all('input, textarea', fields).forEach(function (f) {
        if (f.type !== 'hidden') f.disabled = !box.checked;
      });
    }
    box.addEventListener('change', sync);
    sync();
  });

  /* Accueil : changer la grande photo d'un tableau avec les vignettes */
  all('[data-gallery]').forEach(function (root) {
    var slides = all('[data-slide]', root);
    var thumbs = all('[data-thumb]', root);
    if (!thumbs.length) return;
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        slides.forEach(function (s, j) { s.hidden = j !== i; });
        thumbs.forEach(function (b, j) {
          b.classList.toggle('is-on', j === i);
          b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        });
      });
    });
  });

  /* Accueil, ordinateur seulement : le petit dessin se « grave » quand il apparaît à l'écran */
  var engraveOk = window.matchMedia && window.matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)').matches;
  if (engraveOk && 'IntersectionObserver' in window) {
    var eng = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-engraved');
        setTimeout(function () { e.target.setAttribute('data-play', 'true'); }, 1700);
        eng.unobserve(e.target);
      });
    }, { threshold: 0.35 });
    all('[data-engrave]').forEach(function (el) {
      el.classList.add('is-armed');
      eng.observe(el);
    });
  }

  /* Menu « Boutique » : le bouton ouvre ou ferme les sous-liens ; Échap ou un clic ailleurs les ferme */
  var subs = all('[data-sub]');
  function closeSubs(except) {
    subs.forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var b = li.querySelector('[data-sub-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  subs.forEach(function (li) {
    var btn = li.querySelector('[data-sub-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeSubs(li);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      li.classList.toggle('is-open', open);
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSubs(null);
        btn.focus();
      }
    });
  });
  document.addEventListener('click', function () { closeSubs(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSubs(null); });

  /* Article : bouton « Copier le lien » */
  all('[data-copy-url]').forEach(function (btn) {
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-copy-url');
      function done() {
        btn.textContent = btn.getAttribute('data-copied');
        setTimeout(function () { btn.textContent = label; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      } else {
        window.prompt('', url);
      }
    });
  });


  /* Sélecteur de langue 🌐 : se ferme au clic ailleurs et avec Échap ; flèches haut/bas dans la liste */
  var langMenus = all('[data-lang-menu]');
  function closeLang(except) {
    langMenus.forEach(function (m) { if (m !== except) m.removeAttribute('open'); });
  }
  langMenus.forEach(function (m) {
    m.addEventListener('toggle', function () { if (m.open) closeLang(m); });
    m.addEventListener('keydown', function (e) {
      var opts = all('.lang__option', m);
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'Escape' && m.open) {
        m.removeAttribute('open');
        m.querySelector('summary').focus();
        e.stopPropagation();
      } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!m.open) { m.setAttribute('open', ''); }
        e.preventDefault();
        var next = e.key === 'ArrowDown' ? (i + 1) % opts.length : (i <= 0 ? opts.length - 1 : i - 1);
        if (opts[next]) opts[next].focus();
      }
    });
  });
  document.addEventListener('click', function (e) {
    langMenus.forEach(function (m) { if (!m.contains(e.target)) m.removeAttribute('open'); });
  });


  /* Fiche produit (téléphone) : compteur « 1/8 » de la galerie qui défile */
  all('[data-pgal]').forEach(function (g) {
    var n = g.parentNode.querySelector('[data-pgal-n]');
    if (!n) return;
    var raf = 0;
    g.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = g.clientWidth || 1;
        n.textContent = String(Math.round(g.scrollLeft / w) + 1);
      });
    }, { passive: true });
  });


  /* Fiche produit : visionneuse plein écran des photos (balise <dialog>, sans bibliothèque) */
  all('[data-lb]').forEach(function (dlg) {
    if (typeof dlg.showModal !== 'function') return;
    var wrap = dlg.parentNode;
    var openers = all('[data-lb-open]', wrap);
    var img = dlg.querySelector('[data-lb-img]');
    var stage = dlg.querySelector('[data-lb-stage]');
    var count = dlg.querySelector('[data-lb-count]');
    var tpl = dlg.getAttribute('data-t-counter') || '__N__ / __T__';
    var idx = 0, from = null;

    function show(i) {
      idx = (i + openers.length) % openers.length;
      var o = openers[idx];
      img.classList.remove('is-zoomed');
      img.alt = o.getAttribute('data-lb-alt') || '';
      img.src = o.getAttribute('data-lb-open');
      count.textContent = tpl.replace('__N__', idx + 1).replace('__T__', openers.length);
    }
    function open(i, trigger) {
      from = trigger;
      show(i);
      dlg.showModal();
      var c = dlg.querySelector('[data-lb-close]');
      if (c) c.focus();
    }
    openers.forEach(function (o, i) {
      o.addEventListener('click', function () { open(i, o); });
    });
    dlg.querySelector('[data-lb-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-lb-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.querySelector('[data-lb-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('close', function () {
      img.removeAttribute('src');
      if (from && from.focus) from.focus();
    });
    /* clic à côté de la photo = fermer */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target === stage) dlg.close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(idx - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { show(idx + 1); e.preventDefault(); }
    });
    /* glissement du doigt + double appui = zoom */
    var sx = 0, sy = 0, moved = false, lastTap = 0;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (!img.classList.contains('is-zoomed') && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(dx < 0 ? idx + 1 : idx - 1);
        lastTap = 0;
        return;
      }
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        var now = Date.now();
        if (now - lastTap < 300) {
          var r = img.getBoundingClientRect();
          var z = !img.classList.contains('is-zoomed');
          img.style.transformOrigin = z ? ((t.clientX - r.left) / r.width * 100) + '% ' + ((t.clientY - r.top) / r.height * 100) + '%' : '';
          img.classList.toggle('is-zoomed', z);
          lastTap = 0;
          e.preventDefault();
        } else {
          lastTap = now;
        }
      }
    });
    img.addEventListener('dblclick', function (e) {
      var r = img.getBoundingClientRect();
      var z = !img.classList.contains('is-zoomed');
      img.style.transformOrigin = z ? ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%' : '';
      img.classList.toggle('is-zoomed', z);
    });
  });


  /* Page « Suivre ma commande » : ouvre le suivi du bon transporteur dans un nouvel onglet */
  all('[data-track-form]').forEach(function (form) {
    var num = form.querySelector('[name="q"]');
    var zip = form.querySelector('[name="cp"]');
    var err = form.querySelector('[data-track-error]');
    function fail(msg, field) { err.textContent = msg; err.hidden = false; field.focus(); }
    form.addEventListener('submit', function (e) {
      var code = (num.value || '').replace(/[\s.-]/g, '').toUpperCase();
      var cp = (zip.value || '').replace(/\s/g, '');
      err.hidden = true;
      if (!code) { e.preventDefault(); fail(form.getAttribute('data-t-need-number'), num); return; }
      var url;
      if (/^\d+$/.test(code)) {
        if (!cp) { e.preventDefault(); fail(form.getAttribute('data-t-need-zip'), zip); return; }
        url = 'https://www.mondialrelay.fr/suivi-de-colis/?numeroExpedition=' + encodeURIComponent(code) + '&codePostal=' + encodeURIComponent(cp);
      } else if (/^[A-Z0-9]*[A-Z][A-Z0-9]*$/.test(code) && /\d/.test(code) && code.length >= 11) {
        url = 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + encodeURIComponent(code);
      } else {
        url = 'https://www.google.com/search?q=' + encodeURIComponent(form.getAttribute('data-t-search').replace('__N__', code));
      }
      e.preventDefault();
      window.open(url, '_blank', 'noopener');
    });
  });

  /* Barre d'achat collante : seulement quand le bouton principal est sorti de l'écran par le haut */
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainBuy = document.getElementById('product-buy');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('has-sticky');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var gone = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        sticky.classList.toggle('is-on', gone);
      });
    }).observe(mainBuy);
  }

  /* Accueil : « Détails » d'un tableau ouvert sur ordinateur, replié sur téléphone */
  var wide = window.matchMedia && window.matchMedia('(min-width: 900px)');
  function syncDetails() {
    all('[data-details]').forEach(function (d) { if (wide.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); });
  }
  if (wide) {
    syncDetails();
    if (wide.addEventListener) wide.addEventListener('change', syncDetails);
  }

  /* Filtres de la boutique (boutons Tous, En stock, Personnalisé…) */
  all('[data-filters]').forEach(function (bar) {
    var list = document.querySelector('[data-filter-list]');
    var empty = document.querySelector('[data-filter-empty]');
    if (!list) return;
    var buttons = all('[data-filter-btn]', bar);
    function apply(key) {
      var shown = 0;
      all('.cards__item', list).forEach(function (li) {
        var card = li.querySelector('[data-card]');
        var tags = card ? (card.getAttribute('data-filter') || '').split(' ') : [];
        var ok = key === 'all' || tags.indexOf(key) !== -1;
        li.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-filter-btn') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-filter-btn')); });
    });
  });
})();
